import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AuditAlumni from './audit'
import { Image } from 'antd'

const AlumniCertificationDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [alumniDetail, setAlumniDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAuditVisible, setIsAuditVisible] = useState(false)

  const getAlumniDetail = () => {
    axios.post('/p/alumni/detail/get', {
      merchant_oid: merchantOid,
      alumni_user_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAlumniDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlumniDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (alumniDetail.status.key === 2) return 'green'
    if (alumniDetail.status.key === 3) return 'red'
    return 'black'
  }

  const openAudit = () => {
    setIsAuditVisible(true)
    setPropsData({ 
      oid: alumniDetail.oid,
      status: alumniDetail.status.key,
      failureReason: alumniDetail.failure_reason
    })
  }

  return (
    <Modal 
      title="详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        {(alumniDetail.status && alumniDetail.source === 1) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>认领状态</div>
            <div className='public-datail-content'>{alumniDetail.status.value}</div>
          </div>
        }
        {(alumniDetail.source === 2) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>申请时间</div>
            <div className='public-datail-content'>{alumniDetail.create_time}</div>
          </div>
        }
        {(alumniDetail.claim_time) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>认领时间</div>
            <div className='public-datail-content'>{alumniDetail.claim_time}</div>
          </div>
        }
        <div className='public-datail-item'>
          <div className='public-datail-label'>照片</div>
          <div className='public-datail-photo'>
            <Image src={alumniDetail.photo_url} width={80}/>
          </div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>姓名</div>
          <div className='public-datail-content'>{alumniDetail.name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>身份证号</div>
          <div className='public-datail-content'>{alumniDetail.id_number}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>手机号</div>
          <div className='public-datail-content'>{alumniDetail.phone}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>入学年份</div>
          <div className='public-datail-content'>{alumniDetail.admission_year}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>学院</div>
          <div className='public-datail-content'>{alumniDetail.college}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>专业</div>
          <div className='public-datail-content'>{alumniDetail.major}</div>
        </div>

        {alumniDetail.extra_fields && Object.entries(alumniDetail.extra_fields).map(([key, value], index) => (
          <div className='public-datail-item' key={index}>
            <div className='public-datail-label'>{key}</div>

            <div className='public-datail-content'>
              {Array.isArray(value) && value.length > 0 ? (
                value.join(' ｜ ')
              ) : typeof value === 'string' && value.startsWith('https://oss.yunzhaosoft.com') ? (
                <img
                  src={value}
                  alt={key}
                  style={{ maxWidth: '200px', border: '1px solid #eee' }}
                />
              ) : (
                value
              )}
            </div>
          </div>
        ))}

        {alumniDetail.status && 
          <div className='public-datail-item'>
            <div className='public-datail-label'>状态</div>
            <div style={{ color: getColor() }} className='public-datail-status'>{alumniDetail.status.value}</div>
            {props.showAudit && (<div className='public-datail-button' onClick={openAudit}>审核</div>)}
          </div>
        }
        {(alumniDetail.status && alumniDetail.status.key === 3) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>拒绝原因</div>
            <div className='public-datail-content'>{alumniDetail.failure_reason || '未填写'}</div>
          </div>
        }
      </div>

      {isAuditVisible && <AuditAlumni
        data={propsData}
        getAlumniDetail={getAlumniDetail}
        getAlumniData={() => { props.getAlumniData() }}
        isOpen={isAuditVisible}
        isCancel={() => { setIsAuditVisible(false) }}
      />}
    </Modal>
  )
}

export default AlumniCertificationDetail
